/**
 * Obscure all characters in a string except the last 3 characters.
 * @param {string} str - The string to obscure.
 * @returns {string} The obscured string.
 */
export function obscureString(str) {
    if (str.length <= 3) return str; // Return the string as is if it's 3 characters or less

    const obscuredPart = '*'.repeat(str.length - 3);
    const visiblePart = str.slice(-3);
    return obscuredPart + visiblePart;
}